import { itemDocSchema } from '../../../shared/sync/items';
import { rxdbFromZod } from '../lib/rxdbFromZod';
import { type z } from 'zod/v4';

export type ItemDoc = Omit<z.infer<typeof itemDocSchema>, '_deleted'>;

export const itemSchema = rxdbFromZod(itemDocSchema, {
  indexes: [
    'processId',
    'updatedAt',
    'createdAt',
    'type',
    ['processId', 'createdAt', 'id'],
  ],
  primaryKey: 'id',
  stringMaxLength: { id: 36, processId: 36, type: 16, userId: 64 },
  version: 1,
});
